import PropTypes from 'prop-types';
import ReactSkeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const theme = {
  baseColor: 'var(--background-secondary)',
  highlightColor: 'var(--background-main)',
};

const useAnimationStyles = () => {
  return import('./animations/Blink.css');
};

export const Theme = ({ children }) => {
  useAnimationStyles();

  return <SkeletonTheme {...theme}>{children}</SkeletonTheme>;
};

export const Stub = ({ height, width = '100%' }) => (
  <div style={{ height, width }} data-testid="stub" />
);

function Skeleton({ config, className }) {
  if (Array.isArray(config)) {
    return (
      <Theme>
        {config.map((configItem, idx) =>
          configItem ? (
            <ReactSkeleton
              key={configItem.width}
              className={className}
              {...configItem}
            />
          ) : (
            <br key={idx} /> // eslint-disable-line
          )
        )}
      </Theme>
    );
  }

  return (
    <Theme>
      <ReactSkeleton {...config} className={className} />
    </Theme>
  );
}

Skeleton.propTypes = {
  config: PropTypes.oneOfType([
    PropTypes.shape(),
    PropTypes.arrayOf(PropTypes.shape()),
  ]).isRequired,
};
Skeleton.defaultProps = {
  config: {},
};

export default Skeleton;
